//////////////////
// IMPORTS
//////////////////
// schema
import * as ISchema from "@schema";
// libraries
import * as React from "react";
import { QueryRenderer, ReadyState } from "react-relay";
// chrome-feed imports
import { IRendererProps, IRendererState } from "./AutopilotFeedStatus.d";
import { AutopilotFeedStatus } from "./AutopilotFeedStatus";
import { query } from "./AutopilotFeedStatus.gql";
// util
import { getRenderTimeZone } from "@util/time-zone.util";
import { handleReadyStateError } from "@util/relay.util";

//////////////////
// COMPONENT
//////////////////
export class AutopilotFeedStatusRenderer extends React.PureComponent<
  IRendererProps,
  IRendererState
> {
  private retry?: () => void;
  private refetchInterval?: ReturnType<typeof setInterval>;

  public componentDidMount() {
    this.refetchInterval = setInterval(() => {
      if (this.retry) {
        this.retry();
      }
    }, 30 * 60 * 1000);
  }

  public componentWillUnmount() {
    if (this.refetchInterval) {
      clearInterval(this.refetchInterval);
      delete this.refetchInterval;
    }
  }

  public render() {
    const { environment, orgRelayId, orgTimeZone, fastCrawlFinished, isActionable } = this.props;

    if (!orgTimeZone || !fastCrawlFinished) {
      return null;
    }

    return (
      <QueryRenderer
        environment={environment}
        query={query}
        variables={{ orgRelayId, timeZone: getRenderTimeZone() }}
        cacheConfig={{ force: true }}
        render={(readyState: ReadyState) => {
          // check for error or show a loader for first load
          if (readyState.error) {
            handleReadyStateError(readyState.error, "AutopilotFeedStatusRenderer");

            return null;
          }

          const org = readyState && readyState.props && (readyState.props.org as ISchema.IOrg);
          const user =
            readyState &&
            readyState.props &&
            readyState.props.viewer &&
            (readyState.props.viewer.user as ISchema.IUser);

          if (!org || !user) {
            return null;
          }

          if (readyState.retry) {
            this.retry = readyState.retry;
          }

          return (
            <React.Fragment>
              <AutopilotFeedStatus
                isActionable={isActionable}
                org={org}
                user={user}
                orgTimeZone={this.props.orgTimeZone}
              />
            </React.Fragment>
          );
        }}
      />
    );
  }
}
